export function isvalidPhone(str) {
  const reg =/^1[3|4|5|7|8][0-9]\d{8}$/
  const reg1=/0\d{2,3}-\d{7,8}/
  return reg.test(str) || reg1.test(str)
}
export function isvalidEmail(str) {
  const reg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/i
  return reg.test(str)
}
export function isvalidPwd(str){
const regSpace =/(^\s*)/g
return regSpace.test(str)
}

export function mergeTableRow(data, merge) {
  if (!merge || merge.length === 0) {
    return data
  }
  merge.forEach((m) => {
    const mList = {}
    data = data.map((v, index) => {
      const rowVal = v[m]
      if (mList[rowVal]) {
        mList[rowVal]++
        data[index - (mList[rowVal] - 1)][m + '-span'].rowspan++
        v[m + '-span'] = {
          rowspan: 0,
          colspan: 0
        }
      } else {
        mList[rowVal] = 1
        v[m + '-span'] = {
          rowspan: 1,
          colspan: 1
        }
      }
      return v
    })
  })
  return data
}